import { Component, computed, input, output } from "@angular/core";
import { CouponData } from "../../models/interfaces/coupons.interface";

@Component({
  selector: "app-coupon-card",
  templateUrl: "./coupon-card.component.html",
  host: {
    class: "tw-block tw-h-full",
  },
})
export class CouponCardComponent {
  coupon = input.required<CouponData>();
  redeem = output<string>();

  onRedeem(): void {
    this.redeem.emit(this.coupon().id);
  }
}
